import { useEffect, useRef } from 'react';
import { ehCampoDeEdicao } from '../lib/teclado';

// Atalhos do painel inteiro (quadro do balcão): N abre o Novo pedido, / abre a busca, ? lista os
// atalhos e Esc volta. Nenhuma letra grava nada: as três só abrem telas.

export interface AcoesDosAtalhos {
  novoPedido: () => void;
  buscar: () => void;
  voltar: () => void;
  ajuda: () => void;
}

/** Diálogo aberto (nativo ou modal): ele cuida das teclas, inclusive do Esc que o fecha. */
function temDialogoAberto(): boolean {
  return document.querySelector('dialog[open], [aria-modal="true"]') !== null;
}

function letraDoAtalho(tecla: string): keyof AcoesDosAtalhos | null {
  if (tecla === 'n' || tecla === 'N') return 'novoPedido';
  if (tecla === '/') return 'buscar';
  if (tecla === '?') return 'ajuda';
  return null;
}

/**
 * Esc vale até com o cursor num campo (sair do Novo pedido; o rascunho fica), mas não quando o
 * campo já usou a tecla (fechar sugestões da rua) nem com um diálogo aberto. As letras só valem
 * fora de campo, sem Ctrl/⌘/Alt e fora da composição de acentos (IME).
 */
export function acaoDaTecla(e: KeyboardEvent): keyof AcoesDosAtalhos | null {
  if (e.defaultPrevented || e.isComposing || e.keyCode === 229) return null;
  if (temDialogoAberto()) return null;
  if (e.key === 'Escape') return 'voltar';
  if (e.ctrlKey || e.metaKey || e.altKey || e.repeat) return null;
  if (ehCampoDeEdicao(e.target)) return null;
  return letraDoAtalho(e.key);
}

/** Para onde o Esc volta: o Novo pedido e o pedido voltam à lista; a ficha, à lista dela. */
export function rotaPai(caminho: string): string | null {
  const partes = caminho.split('/').filter(Boolean);
  if (partes.length < 2) return null;
  return `/${partes[0]}`;
}

export function useAtalhosGlobais(acoes: AcoesDosAtalhos): void {
  // As ações mudam a cada render (navegar, abrir); o ouvinte fica um só.
  const atuais = useRef(acoes);
  atuais.current = acoes;

  useEffect(() => {
    const aoTeclar = (e: KeyboardEvent) => {
      const acao = acaoDaTecla(e);
      if (!acao) return;
      e.preventDefault();
      atuais.current[acao]();
    };
    document.addEventListener('keydown', aoTeclar);
    return () => document.removeEventListener('keydown', aoTeclar);
  }, []);
}
